import { createFileRoute } from '@tanstack/react-router'
import RoomsPage from '@/features/rooms/components/rooms-page-house'

export const Route = createFileRoute(
  '/_authenticated/dashboard/houses/$houseId/rooms/',
)({
  component: RoomsPage,
})
